// Compact country list with flag + dial code + aliases for search.
// Aliases enable searches like "UAE" → "United Arab Emirates".

export const COUNTRIES = [
  { code: "IN", flag: "🇮🇳", name: "India", dial: "91", lengths: [10], aliases: ["bharat"] },
  { code: "US", flag: "🇺🇸", name: "United States", dial: "1", lengths: [10], aliases: ["usa", "america"] },
  { code: "GB", flag: "🇬🇧", name: "United Kingdom", dial: "44", lengths: [10, 11], aliases: ["uk", "britain", "england"] },
  { code: "AE", flag: "🇦🇪", name: "United Arab Emirates", dial: "971", lengths: [9], aliases: ["uae", "emirates", "dubai"] },
  { code: "CA", flag: "🇨🇦", name: "Canada", dial: "1", lengths: [10], aliases: [] },
  { code: "AU", flag: "🇦🇺", name: "Australia", dial: "61", lengths: [9], aliases: [] },
  { code: "SG", flag: "🇸🇬", name: "Singapore", dial: "65", lengths: [8], aliases: [] },
  { code: "DE", flag: "🇩🇪", name: "Germany", dial: "49", lengths: [10, 11], aliases: ["deutschland"] },
  { code: "SA", flag: "🇸🇦", name: "Saudi Arabia", dial: "966", lengths: [9], aliases: ["ksa"] },
  { code: "MY", flag: "🇲🇾", name: "Malaysia", dial: "60", lengths: [9, 10], aliases: [] },

  // Full alphabetical list (a curated subset covering 99% of international customers)
  { code: "AF", flag: "🇦🇫", name: "Afghanistan", dial: "93", lengths: [9], aliases: [] },
  { code: "AL", flag: "🇦🇱", name: "Albania", dial: "355", lengths: [9], aliases: [] },
  { code: "DZ", flag: "🇩🇿", name: "Algeria", dial: "213", lengths: [9], aliases: [] },
  { code: "AR", flag: "🇦🇷", name: "Argentina", dial: "54", lengths: [10, 11], aliases: [] },
  { code: "AM", flag: "🇦🇲", name: "Armenia", dial: "374", lengths: [8], aliases: [] },
  { code: "AT", flag: "🇦🇹", name: "Austria", dial: "43", lengths: [10, 11], aliases: [] },
  { code: "AZ", flag: "🇦🇿", name: "Azerbaijan", dial: "994", lengths: [9], aliases: [] },
  { code: "BH", flag: "🇧🇭", name: "Bahrain", dial: "973", lengths: [8], aliases: [] },
  { code: "BD", flag: "🇧🇩", name: "Bangladesh", dial: "880", lengths: [10], aliases: [] },
  { code: "BY", flag: "🇧🇾", name: "Belarus", dial: "375", lengths: [9], aliases: [] },
  { code: "BE", flag: "🇧🇪", name: "Belgium", dial: "32", lengths: [9], aliases: [] },
  { code: "BT", flag: "🇧🇹", name: "Bhutan", dial: "975", lengths: [8], aliases: [] },
  { code: "BO", flag: "🇧🇴", name: "Bolivia", dial: "591", lengths: [8], aliases: [] },
  { code: "BR", flag: "🇧🇷", name: "Brazil", dial: "55", lengths: [10, 11], aliases: [] },
  { code: "BG", flag: "🇧🇬", name: "Bulgaria", dial: "359", lengths: [8, 9], aliases: [] },
  { code: "KH", flag: "🇰🇭", name: "Cambodia", dial: "855", lengths: [8, 9], aliases: [] },
  { code: "CL", flag: "🇨🇱", name: "Chile", dial: "56", lengths: [9], aliases: [] },
  { code: "CN", flag: "🇨🇳", name: "China", dial: "86", lengths: [11], aliases: [] },
  { code: "CO", flag: "🇨🇴", name: "Colombia", dial: "57", lengths: [10], aliases: [] },
  { code: "CR", flag: "🇨🇷", name: "Costa Rica", dial: "506", lengths: [8], aliases: [] },
  { code: "HR", flag: "🇭🇷", name: "Croatia", dial: "385", lengths: [8, 9], aliases: [] },
  { code: "CY", flag: "🇨🇾", name: "Cyprus", dial: "357", lengths: [8], aliases: [] },
  { code: "CZ", flag: "🇨🇿", name: "Czech Republic", dial: "420", lengths: [9], aliases: ["czechia"] },
  { code: "DK", flag: "🇩🇰", name: "Denmark", dial: "45", lengths: [8], aliases: [] },
  { code: "EG", flag: "🇪🇬", name: "Egypt", dial: "20", lengths: [10], aliases: [] },
  { code: "EE", flag: "🇪🇪", name: "Estonia", dial: "372", lengths: [7, 8], aliases: [] },
  { code: "ET", flag: "🇪🇹", name: "Ethiopia", dial: "251", lengths: [9], aliases: [] },
  { code: "FI", flag: "🇫🇮", name: "Finland", dial: "358", lengths: [9, 10], aliases: [] },
  { code: "FR", flag: "🇫🇷", name: "France", dial: "33", lengths: [9], aliases: [] },
  { code: "GE", flag: "🇬🇪", name: "Georgia", dial: "995", lengths: [9], aliases: [] },
  { code: "GH", flag: "🇬🇭", name: "Ghana", dial: "233", lengths: [9], aliases: [] },
  { code: "GR", flag: "🇬🇷", name: "Greece", dial: "30", lengths: [10], aliases: [] },
  { code: "HK", flag: "🇭🇰", name: "Hong Kong", dial: "852", lengths: [8], aliases: [] },
  { code: "HU", flag: "🇭🇺", name: "Hungary", dial: "36", lengths: [8, 9], aliases: [] },
  { code: "IS", flag: "🇮🇸", name: "Iceland", dial: "354", lengths: [7], aliases: [] },
  { code: "ID", flag: "🇮🇩", name: "Indonesia", dial: "62", lengths: [9, 10, 11], aliases: [] },
  { code: "IR", flag: "🇮🇷", name: "Iran", dial: "98", lengths: [10], aliases: [] },
  { code: "IQ", flag: "🇮🇶", name: "Iraq", dial: "964", lengths: [10], aliases: [] },
  { code: "IE", flag: "🇮🇪", name: "Ireland", dial: "353", lengths: [9], aliases: [] },
  { code: "IL", flag: "🇮🇱", name: "Israel", dial: "972", lengths: [9], aliases: [] },
  { code: "IT", flag: "🇮🇹", name: "Italy", dial: "39", lengths: [9, 10], aliases: [] },
  { code: "JP", flag: "🇯🇵", name: "Japan", dial: "81", lengths: [10], aliases: [] },
  { code: "JO", flag: "🇯🇴", name: "Jordan", dial: "962", lengths: [9], aliases: [] },
  { code: "KZ", flag: "🇰🇿", name: "Kazakhstan", dial: "7", lengths: [10], aliases: [] },
  { code: "KE", flag: "🇰🇪", name: "Kenya", dial: "254", lengths: [9, 10], aliases: [] },
  { code: "KW", flag: "🇰🇼", name: "Kuwait", dial: "965", lengths: [8], aliases: [] },
  { code: "LV", flag: "🇱🇻", name: "Latvia", dial: "371", lengths: [8], aliases: [] },
  { code: "LB", flag: "🇱🇧", name: "Lebanon", dial: "961", lengths: [7, 8], aliases: [] },
  { code: "LT", flag: "🇱🇹", name: "Lithuania", dial: "370", lengths: [8], aliases: [] },
  { code: "LU", flag: "🇱🇺", name: "Luxembourg", dial: "352", lengths: [9], aliases: [] },
  { code: "MO", flag: "🇲🇴", name: "Macau", dial: "853", lengths: [8], aliases: [] },
  { code: "MV", flag: "🇲🇻", name: "Maldives", dial: "960", lengths: [7], aliases: [] },
  { code: "MT", flag: "🇲🇹", name: "Malta", dial: "356", lengths: [8], aliases: [] },
  { code: "MX", flag: "🇲🇽", name: "Mexico", dial: "52", lengths: [10], aliases: [] },
  { code: "MA", flag: "🇲🇦", name: "Morocco", dial: "212", lengths: [9], aliases: [] },
  { code: "MM", flag: "🇲🇲", name: "Myanmar", dial: "95", lengths: [8, 9, 10], aliases: ["burma"] },
  { code: "NP", flag: "🇳🇵", name: "Nepal", dial: "977", lengths: [10], aliases: [] },
  { code: "NL", flag: "🇳🇱", name: "Netherlands", dial: "31", lengths: [9], aliases: ["holland"] },
  { code: "NZ", flag: "🇳🇿", name: "New Zealand", dial: "64", lengths: [8, 9, 10], aliases: [] },
  { code: "NG", flag: "🇳🇬", name: "Nigeria", dial: "234", lengths: [10], aliases: [] },
  { code: "NO", flag: "🇳🇴", name: "Norway", dial: "47", lengths: [8], aliases: [] },
  { code: "OM", flag: "🇴🇲", name: "Oman", dial: "968", lengths: [8], aliases: [] },
  { code: "PK", flag: "🇵🇰", name: "Pakistan", dial: "92", lengths: [10], aliases: [] },
  { code: "PS", flag: "🇵🇸", name: "Palestine", dial: "970", lengths: [9], aliases: [] },
  { code: "PA", flag: "🇵🇦", name: "Panama", dial: "507", lengths: [7, 8], aliases: [] },
  { code: "PE", flag: "🇵🇪", name: "Peru", dial: "51", lengths: [9], aliases: [] },
  { code: "PH", flag: "🇵🇭", name: "Philippines", dial: "63", lengths: [10], aliases: [] },
  { code: "PL", flag: "🇵🇱", name: "Poland", dial: "48", lengths: [9], aliases: [] },
  { code: "PT", flag: "🇵🇹", name: "Portugal", dial: "351", lengths: [9], aliases: [] },
  { code: "QA", flag: "🇶🇦", name: "Qatar", dial: "974", lengths: [8], aliases: [] },
  { code: "RO", flag: "🇷🇴", name: "Romania", dial: "40", lengths: [9], aliases: [] },
  { code: "RU", flag: "🇷🇺", name: "Russia", dial: "7", lengths: [10], aliases: [] },
  { code: "RW", flag: "🇷🇼", name: "Rwanda", dial: "250", lengths: [9], aliases: [] },
  { code: "RS", flag: "🇷🇸", name: "Serbia", dial: "381", lengths: [8, 9], aliases: [] },
  { code: "SK", flag: "🇸🇰", name: "Slovakia", dial: "421", lengths: [9], aliases: [] },
  { code: "SI", flag: "🇸🇮", name: "Slovenia", dial: "386", lengths: [8], aliases: [] },
  { code: "ZA", flag: "🇿🇦", name: "South Africa", dial: "27", lengths: [9], aliases: [] },
  { code: "KR", flag: "🇰🇷", name: "South Korea", dial: "82", lengths: [9, 10], aliases: ["korea"] },
  { code: "ES", flag: "🇪🇸", name: "Spain", dial: "34", lengths: [9], aliases: [] },
  { code: "LK", flag: "🇱🇰", name: "Sri Lanka", dial: "94", lengths: [9], aliases: [] },
  { code: "SE", flag: "🇸🇪", name: "Sweden", dial: "46", lengths: [9], aliases: [] },
  { code: "CH", flag: "🇨🇭", name: "Switzerland", dial: "41", lengths: [9], aliases: [] },
  { code: "TW", flag: "🇹🇼", name: "Taiwan", dial: "886", lengths: [9], aliases: [] },
  { code: "TZ", flag: "🇹🇿", name: "Tanzania", dial: "255", lengths: [9], aliases: [] },
  { code: "TH", flag: "🇹🇭", name: "Thailand", dial: "66", lengths: [9], aliases: [] },
  { code: "TR", flag: "🇹🇷", name: "Turkey", dial: "90", lengths: [10], aliases: [] },
  { code: "UG", flag: "🇺🇬", name: "Uganda", dial: "256", lengths: [9], aliases: [] },
  { code: "UA", flag: "🇺🇦", name: "Ukraine", dial: "380", lengths: [9], aliases: [] },
  { code: "UY", flag: "🇺🇾", name: "Uruguay", dial: "598", lengths: [8], aliases: [] },
  { code: "VN", flag: "🇻🇳", name: "Vietnam", dial: "84", lengths: [9, 10], aliases: [] },
  { code: "YE", flag: "🇾🇪", name: "Yemen", dial: "967", lengths: [9], aliases: [] },
  { code: "ZM", flag: "🇿🇲", name: "Zambia", dial: "260", lengths: [9], aliases: [] },
  { code: "ZW", flag: "🇿🇼", name: "Zimbabwe", dial: "263", lengths: [9], aliases: [] },
];

export const TOP_CODES = ["IN", "US", "GB", "AE", "CA", "AU", "SG", "DE", "SA", "MY"];

export function findByCode(code) {
  return COUNTRIES.find((c) => c.code === code) || COUNTRIES[0];
}

export function isValidPhone(country, digits) {
  if (!country) return false;
  return country.lengths.includes((digits || "").length);
}

export function searchCountries(query) {
  const q = query.trim().toLowerCase();
  if (!q) return COUNTRIES;
  // accept dial code search "+971" or "971"
  const digitMatch = q.replace(/^\+/, "");
  return COUNTRIES.filter((c) => {
    if (c.name.toLowerCase().includes(q)) return true;
    if (c.aliases.some((a) => a.includes(q))) return true;
    if (digitMatch && /^\d+$/.test(digitMatch) && c.dial.startsWith(digitMatch)) return true;
    return false;
  });
}
